import React from "react";

//import { ChatManager } from "../../features/chat/ChatManager";
import { ScrapbookManager } from "../../managers/ScrapbookManager";
import { ManningOnlineStore } from "vbook-ui-components/src/subscriptions/store/ManningOnlineStore";
import { ManningOnlineWebProvider } from "vbook-ui-components/src/subscriptions/providers/manningOnlineProvider/ManningOnlineWebProvider";
import { ReadingListProvider } from "vbook-ui-components/src/subscriptions/providers/readingList/ReadingListProvider";
import { ReadingListWebProvider } from "vbook-ui-components/src/subscriptions/providers/readingList/ReadingListWebProvider";
import { TagsProvider } from "vbook-ui-components/src/subscriptions/providers/tags/TagsProvider";
import { SourceApp } from "vbook-ui-components/src/Config";
import { GlobalStateInfo } from "../../utils/GlobalStateInfo";
import { TagsWebProvider } from "vbook-ui-components/src/subscriptions/providers/tags/TagsWebProvider";
import { ManningOnlineProvider } from "vbook-ui-components/src/subscriptions/providers/manningOnlineProvider/ManningOnlineProvider";
import { DynamicCodeLoader } from "../../utils/DynamicCodeLoader";
import { ManningOnlineTourModal, TourModalStep } from "vbook-ui-components/src/subscriptions/components/manningOnlineTour/ManningOnlineTourModal";
import { LocalStorageUtils } from "../../utils/LocalStorageUtils";
import { IManningOnlineTourState, ManningOnlineTour } from "./ManningOnlineTour";
import { ManningOnlineDesktopTourModal } from "vbook-ui-components/src/subscriptions/components/manningOnlineTour/ManningOnlineDesktopTour";
import EventUtils from "../../utils/EventUtils";
import { ReactUtils } from "../../utils/ReactUtils";
import { AuthProvider } from "../../services/authService/AuthProvider";
import { IUserDetails } from "../../services/userService/UserService";
import { NewDiscussionModule } from "../../features/newDiscussions/NewDiscussionsModule";
import SocialWebProvider from 'vbook-ui-components/src/social/providers/SocialWebProvider';
import { SearchCatalogStoreProviderWeb } from "vbook-ui-components/src/search-catalog/providers/SearchCatalogStoreProviderWeb";


class ManningOnlineManagerClass {    
    private store: ManningOnlineStore;
    private tourState: IManningOnlineTourState;
    private socialWebProvider: SocialWebProvider;

    constructor(){
        this.socialWebProvider = new SocialWebProvider(SourceApp.livebook, GlobalStateInfo.getDeploymentType());
    }

    private createAuthorizedProductsMap(authorizedProductIds) {
        const map = {};
        if(!authorizedProductIds || !authorizedProductIds.length) { return map; }

        for(const id of authorizedProductIds){
            map[id] = true;
        }
        
        return map;
    }

    public getStore(): ManningOnlineStore {
        if(this.store != null) { return this.store; }
        
        this.store = new ManningOnlineStore(
            new ManningOnlineProvider(new ManningOnlineWebProvider(SourceApp.livebook, GlobalStateInfo.getDeploymentType())),
            new ReadingListProvider(new ReadingListWebProvider(SourceApp.livebook, GlobalStateInfo.getDeploymentType())),
            new TagsProvider(new TagsWebProvider(SourceApp.livebook, GlobalStateInfo.getDeploymentType())),
            ScrapbookManager.getStore()
        );

        this.store.useSearchCatalog(new SearchCatalogStoreProviderWeb(
            SourceApp.livebook,
            GlobalStateInfo.getDeploymentType()
        ));

        let isLibraryTagSelected = this.store.isLibraryTabSelected();
        const handleChange = () => {
            if(this.store.isLibraryTabSelected() && !isLibraryTagSelected){
                isLibraryTagSelected = true;
                this.store.offCatalogChange(handleChange);
                GlobalStateInfo.sendUserAction({type: "search-catalog", additionalData: "manning-online-search-catalog"});
            }
        };

        this.store.onCatalogChange(handleChange);

        AuthProvider.isLoggedIn().then(authInfo => {
            if(authInfo != null && authInfo.loggedIn && authInfo.userDetails != null && authInfo.userDetails.email.indexOf("@manning.com") > 0){
                let userDetails = authInfo.userDetails;

                this.socialWebProvider.getUsersCommentInfo().then(usersCommentInfo => {
                    userDetails.authorizedProductIds = this.createAuthorizedProductsMap(usersCommentInfo.authorizedProductIds) || {};
                    this.includeDiscussions(userDetails);
                });
            }
        });


        ManningOnlineTour.getTourState().then(tourState => {
            this.tourState = tourState;
        });

        this.store.onBeforeDesktopToggle = () => {
            const result = this.tourState == null || this.tourState.hasSeenDesktopTour;

            if(!result){
                EventUtils.setTimeout(() => {
                    this.renderDesktopTour(this.tourState);
                }, 150);
            }
            
            return result;
        };

        return this.store;
    }

    private includeDiscussions(user: IUserDetails){
        NewDiscussionModule.getDiscussionsComponent().then(({NewDiscussionsComponent}) => {
            this.store.setDiscussionsComponent(NewDiscussionsComponent.getDiscussionsComponentForManningOnline(user));
        });
    }

    public showTourIfNeeded(){
        if(LocalStorageUtils.getItem("MO_INTRO_TOUR_SEEN")) { return; }
        
        ManningOnlineTour.getTourState().then(tourState => {
            this.getStore().tourState = tourState;
            if(!tourState.hasSeenIntroStartModal){
                this.showIntroTourModal(tourState);
                return;
            }
        });
    }

    public showIntroTourModal(tourState: IManningOnlineTourState){
        tourState.hasSeenIntroStartModal = true;
        LocalStorageUtils.setItem("MO_INTRO_TOUR_SEEN", true);
        ManningOnlineTour.storeTourState(tourState);

        const root = ReactUtils.createRoot(document.getElementById("full-screen-modal"));
        root.render(React.createElement(ManningOnlineTourModal, {
            isOpen: true,
            tourModalStep: TourModalStep.Start,
            onAction: () => {
                tourState.hasSeenIntroStartModal = true;
                ManningOnlineTour.storeTourState(tourState);
                DynamicCodeLoader.loadShepherd().then(() => {
                    this.showEndTourModal(tourState);
                    this.closeTourModal();
                }).catch(() => this.closeTourModal());
            },
            onClose: () => {
                tourState.hasSeenIntroStartModal = true;
                tourState.hasSeenIntroEndModal = true;
                ManningOnlineTour.storeTourState(tourState);
                this.closeTourModal();
            },
        }));
    }

    public showEndTourModal(tourState: IManningOnlineTourState){
        tourState.hasSeenIntroEndModal = true;
        ManningOnlineTour.storeTourState(tourState);
        
        const root = ReactUtils.createRoot(document.getElementById("full-screen-modal"));
        root.render(React.createElement(ManningOnlineTourModal, {
            isOpen: true,
            tourModalStep: TourModalStep.End,
            onAction: () => this.closeTourModal(),
            onClose: ()  => {
                this.closeTourModal();
            },
            onMap: () => {
                this.closeTourModal();
                //ReaderMapModule.open();
            },
            onChat: () => {
                this.closeTourModal();
                //ChatModule.initialize(-1, true);
            },
            onScrapbook: () => {
                this.closeTourModal();
                this.store.scrapbookStore.toggleShown();
            },
            onDesktop: () => {
                this.closeTourModal();
                this.store.toggleDesktop();
            }
        }));
    }

    public renderDesktopTour(tourState: IManningOnlineTourState){
        tourState.hasSeenDesktopTour = true;
        ManningOnlineTour.storeTourState(tourState);
        
        const root = ReactUtils.createRoot(document.getElementById("full-screen-modal"));
        root.render(React.createElement(ManningOnlineDesktopTourModal, {
            onClose: () => {
                tourState.hasSeenDesktopTour = true;
                ManningOnlineTour.storeTourState(tourState);
                this.closeTourModal();
                this.store.toggleDesktop();
            },
        }));
    }

    private closeTourModal(){
        ReactUtils.unmountAtNode(document.getElementById("full-screen-modal"));
    }
}

export const ManningOnlineManager = new ManningOnlineManagerClass();